export const decodeBase64String = (encodedBase64String: string) => {
  return JSON.parse(atob(encodedBase64String.slice(2, -2)));
};
